import axiosInstance from "./axiosInstance";

export const getAvailablePluginCategories = async (
  mac: string,
  target: string = "entity_inspector",
) => {
  const response = await axiosInstance.post("/getAvailablePluginCategories/", {
    mac,
    target,
  });
  return response.data;
};

export const getPluginFrontendTemplate = async (
  id: string,
  mac: string,
  ip: string,
  template: string,
  dataFunction: string,
  filterTime: string = "day",
) => {
  const response = await axiosInstance.post(
    "/plugin/" + id + "/frontend",
    { mac, ip, template, dataFunction, filterTime },
    {
      headers: {
        Accept: "text/html",
      },
    },
  );
  return response.data;
};
